import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import styled from "styled-components";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
const StyledShareSection = styled.div`
  & > div {
    width: 100%;
  }

  width: 100%;
`;
function ShareFormField({ field, description = void 0, entityType = void 0 }) {
  const [{ value }, _m, { setValue, setTouched }] = useField({ name: field.name });
  const onSetEntityShare = useCallback(
    (sharePayload) => {
      setValue(sharePayload);
      setTouched(true);
    },
    [setTouched, setValue]
  );
  return /* @__PURE__ */ React.createElement(StyledShareSection, null, /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description,
      entityType,
      onSetEntityShare,
      defaultSharePayload: value
    }
  ));
}
export default ShareFormField;
